module.exports = __webpack_public_path__ + "img/kefu.7c8da583.png";